import React, { useContext, useEffect } from 'react';
import { Link, BrowserRouter } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { BlobParam } from '../../utils/SiteTools';

import NavigationModal from '../NavigationModal/NavigationModal';
import Modal from '../Modal/Modal';

import CategoryDemoContext from '../../utils/CategoryDemo/context';
import useAxios from '../../utils/hooks/useAxios';
import { lobSourceName, lobRoot, LobPartnerLabel, LobPrivateBankLabel } from '../../utils/LobLogicModule';
import ReleatedLinks from '../../utils/RelatedLinks';
import { header } from './data/header.json';
import './Header.scss';

/**
 * Header component
 * Manages the header that is shown in all pages
 * @param selectorKey - The name of the subpage to know wich content should be shown
 */

const Header = ({ selectorKey, categoriesData, errorId }) => {
    const { t, i18n } = useTranslation('header');
    const pageHeader = header[selectorKey];
    const { setCategoryDemoData } = useContext(CategoryDemoContext);
    const sourceName = lobSourceName;
    const search = window.location.search;
    /**
     * - Used categoriesData passed from App.js
     * - Fetched Demo list and saperated data accroding to mobile & online demo
     * - Stored online and mobile demo in categoryData under submenu object
     */
    const { data } = useAxios(process.env.REACT_APP_GCDEV_API_DEMO_LIST+sourceName);
    let relatedLink = sourceName ==='' ? ReleatedLinks() : [];
    // created Demo's data object and pushed it in categoriesData Context to use across app
    useEffect(() => {
        if(categoriesData !==undefined && relatedLink !==undefined){
            let onlineDemo = data && data.filter(demo => demo.path.match('online') && demo).concat(relatedLink.filter(demo => demo.path.match('online') && demo));
            let mobileDemo = data && data.filter(demo => demo.path.match('mobile') && demo).concat(relatedLink.filter(demo => demo.path.match('mobile') && demo));
            let mposDemo = data && data.filter(demo => demo.path.match('mpos') && demo).concat(relatedLink.filter(demo => demo.path.match('mpos') && demo));
            let essentialsDemo = data && data.filter(demo => demo.path.match('essentials') && demo).concat(relatedLink.filter(demo => demo.path.match('essentials') && demo));
            let restaurantDemo = data && data.filter(demo => demo.path.match('restaurant') && demo).concat(relatedLink.filter(demo => demo.path.match('restaurant') && demo));
            let retailDemo = data && data.filter(demo => demo.path.match('retail') && demo).concat(relatedLink.filter(demo => demo.path.match('retail') && demo));
            
            categoriesData.map( categoryItem => {
                categoryItem.submenu = {
                    mobileDemo: [],
                    onlineDemo: [],
                    mposDemo: [],
                    essentialsDemo: [],
                    restaurantDemo: [],
                    retailDemo: []
                };
                
                /**
                 * This handled the way to consume the categories 
                 *  @categories = [] comes from the API
                 */
                categoryItem.submenu.onlineDemo = onlineDemo && onlineDemo.filter( onlineItem => {
                    return categoryItem.path === onlineItem.categories[0] || categoryItem.path === onlineItem.categories[1] ||categoryItem.path === onlineItem.categories[2] || categoryItem.path === onlineItem.categories[3] || categoryItem.path === onlineItem.categories[4] || categoryItem.path === onlineItem.categories[5] || categoryItem.path === onlineItem.categories[6] || categoryItem.path === onlineItem.categories[7];
                });

                categoryItem.submenu.mobileDemo = mobileDemo && mobileDemo.filter( mobileItem => {
                    return categoryItem.path === mobileItem.categories[0] || categoryItem.path === mobileItem.categories[1] ||categoryItem.path === mobileItem.categories[2] || categoryItem.path === mobileItem.categories[3] || categoryItem.path === mobileItem.categories[4] || categoryItem.path === mobileItem.categories[5] || categoryItem.path === mobileItem.categories[6] || categoryItem.path === mobileItem.categories[7];
                });

                categoryItem.submenu.mposDemo = mposDemo && mposDemo.filter( mposItem => {
                    return categoryItem.path === mposItem.categories[0] || categoryItem.path === mposItem.categories[1] ||categoryItem.path === mposItem.categories[2] || categoryItem.path === mposItem.categories[3] || categoryItem.path === mposItem.categories[4] || categoryItem.path === mposItem.categories[5] || categoryItem.path === mposItem.categories[6] || categoryItem.path === mposItem.categories[7];
                });

                categoryItem.submenu.essentialsDemo = essentialsDemo && essentialsDemo.filter( essentialsItem => {
                    return categoryItem.path === essentialsItem.categories[0] || categoryItem.path === essentialsItem.categories[1] ||categoryItem.path === essentialsItem.categories[2] || categoryItem.path === essentialsItem.categories[3] || categoryItem.path === essentialsItem.categories[4] || categoryItem.path === essentialsItem.categories[5] || categoryItem.path === essentialsItem.categories[6] || categoryItem.path === essentialsItem.categories[7];
                });

                categoryItem.submenu.restaurantDemo = restaurantDemo && restaurantDemo.filter( restaurantItem => {
                    return categoryItem.path === restaurantItem.categories[0] || categoryItem.path === restaurantItem.categories[1] ||categoryItem.path === restaurantItem.categories[2] || categoryItem.path === restaurantItem.categories[3] || categoryItem.path === restaurantItem.categories[4] || categoryItem.path === restaurantItem.categories[5] || categoryItem.path === restaurantItem.categories[6] || categoryItem.path === restaurantItem.categories[7];
                });

                categoryItem.submenu.retailDemo = retailDemo && retailDemo.filter( retailItem => {
                    return categoryItem.path === retailItem.categories[0] || categoryItem.path === retailItem.categories[1] ||categoryItem.path === retailItem.categories[2] || categoryItem.path === retailItem.categories[3] || categoryItem.path === retailItem.categories[4] || categoryItem.path === retailItem.categories[5] || categoryItem.path === retailItem.categories[6] || categoryItem.path === retailItem.categories[7];
                });

                return true;
            });
            
            setCategoryDemoData(categoriesData);

            
        }
    }, [setCategoryDemoData, categoriesData, data, relatedLink]);

    const NavLogo = () => {
        let Logo;

        switch(lobRoot) {
            case '/ml':
                Logo = () => (
                    <Link id="Nav_Logo" to={ lobRoot + BlobParam(search) } data-component="Header" data-bactmln="Nav-_-Global_Head-_-BofAlogo">
                        <img className="ml-logo-img" src={`${process.env.PUBLIC_URL}/assets/images/merrill_logo.svg`} alt={pageHeader.heading_ml}/>
                    </Link>
                );
                break;
            case '/sb/smallbusiness':
                Logo = () => (
                    <Link id="Nav_Logo" to={ lobRoot + BlobParam(search) } data-component="Header" data-bactmln="Nav-_-Global_Head-_-BofAlogo">
                        <img src="/global/assets/images/logo-bac-horiz-1.0.0.svg" alt={pageHeader.heading_alt}/>
                        {`${LobPartnerLabel}`.length > 0 ? <span className="sb_label">{LobPartnerLabel}</span> : ''}
                    </Link>
                );
                break;
            case '/privatebank':
                Logo = () => (
                    <Link id="Nav_Logo" to={ lobRoot + BlobParam(search) } data-component="Header" data-bactmln="Nav-_-Global_Head-_-BofAlogo">
                        <img src="/global/assets/images/logo-bac-horiz-1.0.0.svg" alt={pageHeader.heading_alt}/>
                        {`${LobPrivateBankLabel}`.length > 0 ? <span className="pb_label">{LobPrivateBankLabel}</span> : ''}
                    </Link>
                );
                break;
            default:
                Logo = () => (
                    <div>
                    {i18n.language === 'es' ? <Modal url={ `${process.env.PUBLIC_URL}` + lobRoot + BlobParam(search) } target='_self' component="Header" className="t-track-body-copy-link"  dataTag={`Nav-_-Global_Head-_-BofAlogo`} dataModal={`Exit_Lang`} linkName={(t(pageHeader.bofaLogo))} contentId="interstitial"/>
                    :
                    <Link id="Nav_Logo" to={ lobRoot + BlobParam(search) }  data-component="Header" data-bactmln="Nav-_-Global_Head-_-BofAlogo">
                        <img src="/global/assets/images/logo-bac-horiz-1.0.0.svg" alt={pageHeader.heading_alt}/>
                    </Link>
                    }
                    </div>
                );
                break;
        };

        return (
            <div className="boa_logo">
                { errorId !== 102 ?
                    <Logo />
                :
                    <BrowserRouter>
                        <Logo />
                    </BrowserRouter>
                }
            </div>
        );
    };

    return (
        <div className="container_wrapper header" data-action="header" id="header" role="banner">
            {pageHeader.heading_ada_text &&
                <button id="adaFriendlyButton" className="adaFriendly button-link-style" dangerouslySetInnerHTML={{ __html: t(pageHeader.heading_ada_text) }}></button>
            }
            <div className="header_wrapper">
                <div className="boa_container">
                    <NavLogo />
                    
                    <div className="login-cta hide">
                        {i18n.language === 'es' ? <Modal url={`https://www.bankofamerica.com/deeplink/redirect.go?target=bofasignin&amp;screen=Accounts:Home&amp;version=7.0.0`} target='_blank' component="a" className="t-track-body-copy-link"  dataTag={`Navigation-_-Hyperlink-_-Signin`} dataModal={`Exit_Lang`} linkName={(t(pageHeader.signin))} contentId="interstitial"/> : <a href="https://www.bankofamerica.com/deeplink/redirect.go?target=bofasignin&amp;screen=Accounts:Home&amp;version=7.0.0" className="t-track-link" rel="noopener noreferrer" target="_blank" data-bactmln="Navigation-_-Click-_-Signin" dangerouslySetInnerHTML={{ __html: t(pageHeader.signin)}}></a>}
                    </div>
                </div>
                { errorId !== 102 ?
                <div className="nav_dropdown">
                    <NavigationModal id="Nav_Menu_Dropdown" />
                </div>
                :
                ''
                }
            </div>
        </div>
    );
};

export default Header;